import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { InteractionStatus } from '@azure/msal-browser';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Observable, filter, map, of, take } from 'rxjs';
import { UserService } from './user.service';
@Injectable({
  providedIn: 'root',
})
export class RoleGaurd {
  constructor(
    private userService: UserService,
    public msalBroadCastService: MsalBroadcastService,
    private authService: MsalService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean> {
    const roles = route.data['roles'] as string[];
    const currentRole = this.userService.roleCheck(route.data?.['roles']);
    if (currentRole) {
      return of(currentRole);
    }
    // On a fresh page load the roles aren't known yet, so read them from the signed-in account once MSAL has finished starting up
    return this.msalBroadCastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      take(1),
      map(() => {
        const account = this.authService.instance.getActiveAccount() ?? this.authService.instance.getAllAccounts()[0];
        if (!account || account.username.indexOf('geothermusa.com') <= 1) {
          return false;
        }
        const userRoles = (account.idTokenClaims?.roles as string[] | undefined) ?? [];
        return userRoles.some((userRole) => roles.includes(userRole));
      }),
    );
  }
}
